<template>
  <div>
      <v-card class="overflow-x-auto w-100" >
        <v-toolbar flat dark color="indigo ">
            <v-text-field
                :placeholder="$t('sector.search')"
                v-model="util.query"
                clearable
                prepend-icon="mdi-magnify"
                class="pt-4"
                :disabled="util.loading"
                :loading="util.loadingTree"
            ></v-text-field>
        </v-toolbar>
        <div style="max-width: 100%; overflow-x: auto;">
            <v-treeview v-if="!util.loading" 
            style="min-width: 30rem;"
            :search="util.query"
            :active.sync="sectors.active"
            @update:active="selectSector"
            return-object
            color="purple" 
            :items="sectors.list" 
            activatable
            ref="listado"
            :load-children="util.fullTreeLoaded ? undefined : getChildren"
            :open.sync="sectors.open"
            transition
        >
            <template v-slot:prepend="{ item, open }">
                <v-icon class="cursor-pointer" v-if="item.children && item.children.length" :class="[item.sectorSlave? 'green--text': '']">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
                <v-icon class="cursor-pointer" :class="[item.sectorSlave? 'green--text': '']" v-else>
                    mdi-domain
                </v-icon>
            </template>
            <template v-slot:label="{item, active}">
                <div style="line-height: 1rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="cursor-pointer">
                    <span style="font-size: 12px;" :class="{'font-weight-bold':active}">{{item.name}}</span>
                </div>
                <div style="font-size: 10px; line-height: 0.85rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="grey--text">
                    {{getName(item.type?.names)}}
                    <span v-if="item.hospitalUnitName" class="ml-1">
                        • {{ item.hospitalUnitName }}
                    </span>
                </div>
            </template>
        </v-treeview>
        </div>
        
        <div class="text-center " v-if="util.loading" >
            <v-progress-circular indeterminate></v-progress-circular>
            <div class="text-overline">{{ $t('loading.text') }}</div>
        </div>
      </v-card>
  </div>
</template>

<script>
import sectorServices from '../../../services/sectorServices'
import translateService from '@/helper/translateService.js'
export default {
    props:["sectorId", "updater", "onlyMaster"],
    data(){return {
        util:{
            sector:{},
            loading: true,
            loadingTree: false,
            fullTreeLoaded: false,
            openBeforeSearch: null,
            query: '',
            selected:[]
        },
        sectors:{
            list: [],
            active: [],
            open:[]
        }
        
    }},
    mounted(){
        // Suporta múltiplas raízes se houver múltiplos setores
        const appSectors = this.$store.getters['app/sectors'];
        if(appSectors && appSectors.length > 0){
            this.sectors.list = appSectors;
        } else {
            // Fallback para um único setor
            this.sectors.list = [this.$store.getters['app/sector']];
        }

        if(!this.sectorId){
            // Seleciona o primeiro setor da lista
            const firstSector = this.sectors.list[0];
            if(firstSector){
                this.selectSector([firstSector]);
            }
        }
        this.util.loading = false;
        
    },
    watch:{
        'util.query': function(val){
            if(val && val.trim().length > 0){
                this.loadFullTree().then(() => this.applySearchOpen(this.util.query));
            }else{
                this.applySearchOpen('');
            }
        },
        updater : function(val){
            if(val.id !== this.util.selected.id){
                this.changeExternalSector(val)
            }
        }
    },
    methods:{
        selectSector(sectorCheck){
            
            if(sectorCheck.length > 0 && Array.isArray(sectorCheck)){
                let checked = sectorCheck[0];
                // O v-treeview reemite 'update:active' quando a lista de itens é
                // reconstruída (ex.: carga da árvore completa). Sem esta guarda o
                // setor atual seria reemitido e as telas consumidoras recarregariam.
                const unchanged = this.util.selected && this.util.selected.id === checked.id;
                this.util.selected = checked;
                this.sectors.active = [checked]
                if(unchanged) return;
                this.$emit("selected", checked);
                this.$emit("isSlave", checked.sectorSlave);
            } else {
                this.util.selected = null;
                this.sectors.active = [];
                //this.$emit("selected", null);
                //this.$emit("isSlave", null);
            }
        },
        getName(names){
            return translateService.getName(names);
        },
        getChildren(sectorItem){
            if(this.onlyMaster && !sectorItem.type?.enableMaster){
                return ;
            }
            return sectorServices.getChildren(sectorItem.id, this.$store.state.current.stage.id).then(resp => {
                if(this.onlyMaster){
                    resp.data = resp.data.filter(s => s.type?.enableMaster);
                }
                // Ordena os setores por 'sorter'
                sectorItem.children = resp.data.sort((a, b) => (a.sorter || 0) - (b.sorter || 0));
            })
        },
        // O v-treeview filtra apenas o que já está em memória. Como a árvore é
        // carregada sob demanda, a busca só encontrava os setores que o usuário
        // já tinha expandido. Na primeira busca trazemos a hierarquia completa
        // de uma vez e desligamos o lazy load.
        async loadFullTree(){
            if(this.util.fullTreeLoaded || this.util.loadingTree) return;

            const roots = this.sectors.list.filter(s => s && s.id);
            if(roots.length === 0) return;

            const stageId = this.$store.state.current.stage.id;
            this.util.loadingTree = true;
            try{
                const responses = await Promise.all(
                    roots.map(r => sectorServices.getChildSectors(r.id, stageId).catch(() => ({data: []})))
                );

                // 'sector/children/all' é recursivo e já devolve a própria raiz
                const flat = [...roots];
                responses.forEach(resp => {
                    if(Array.isArray(resp.data)) flat.push(...resp.data);
                });

                this.sectors.list = this.buildTree(flat, roots.map(r => r.id));
                this.util.fullTreeLoaded = true;
                // trocar 'items' faz o v-treeview limpar os caches de ativo/aberto;
                // só dá para reaplicar o estado depois que ele reconstruiu a árvore
                await this.$nextTick();
                this.restoreSelection();
                this.applySearchOpen(this.util.query);
            }catch(e){
                console.error('Erro ao carregar a hierarquia completa de setores', e);
            }finally{
                this.util.loadingTree = false;
            }
        },
        buildTree(flat, rootIds){
            const nodes = new Map();
            flat.forEach(s => {
                if(!s || nodes.has(s.id)) return;
                if(this.onlyMaster && !s.type?.enableMaster && !rootIds.includes(s.id)) return;
                nodes.set(s.id, {...s, children: []});
            });

            const tree = [];
            nodes.forEach(node => {
                const parent = nodes.get(node.masterId);
                if(rootIds.includes(node.id) || !parent || parent.id === node.id){
                    tree.push(node);
                }else{
                    parent.children.push(node);
                }
            });

            // Ordena os filhos por 'sorter', preservando a ordem original das raízes
            const sortDeep = list => {
                list.forEach(n => {
                    n.children.sort((a, b) => (a.sorter || 0) - (b.sorter || 0));
                    sortDeep(n.children);
                });
            };
            sortDeep(tree);
            return tree;
        },
        // O v-treeview esconde os nós que não casam com a busca, mas não expande
        // os pais dos que casam (ele só renderiza filhos de nó aberto). Sem isto
        // o resultado fica carregado, porém invisível.
        applySearchOpen(query){
            const term = (query || '').trim().toLocaleLowerCase();

            if(!term){
                if(this.util.openBeforeSearch){
                    this.sectors.open = this.util.openBeforeSearch;
                    this.util.openBeforeSearch = null;
                }
                return;
            }

            if(!this.util.openBeforeSearch){
                this.util.openBeforeSearch = [...this.sectors.open];
            }

            // mesma regra do v-treeview: o nó fica visível se ele ou algum
            // descendente casa com o termo
            const toOpen = [];
            const visit = node => {
                const selfMatch = (node.name || '').toLocaleLowerCase().indexOf(term) > -1;
                let childMatch = false;
                (node.children || []).forEach(child => {
                    if(visit(child)) childMatch = true;
                });
                // expande apenas nós com filhos; passar uma folha para 'open'
                // faz o v-treeview entrar em laço tentando carregar filhos
                if(childMatch) toOpen.push(node);
                return selfMatch || childMatch;
            };
            this.sectors.list.forEach(visit);

            this.sectors.open = toOpen;
        },
        restoreSelection(){
            // buildTree cria novas instâncias; reaponta a seleção para o novo nó
            const id = this.util.selected?.id;
            if(!id) return;
            for(const root of this.sectors.list){
                const node = this.findSectorFather(id, root);
                if(node){
                    this.util.selected = node;
                    this.sectors.active = [node];
                    return;
                }
            }
        },
        changeExternalSector(sectorCheck){
            this.util.selected = sectorCheck;
            this.sectors.active = [sectorCheck]
        },
        addExternalSector(sector){
            const fatherSector = this.findSectorFather(sector.masterId, this.sectors.list[0]);
            if(fatherSector){
                fatherSector.children.push(sector);
            }else{
                console.log("no se encuentra master con ID " + sector.masterId );
                console.log(this.sectors.list[0]);
            }
        },
        findSectorFather(id, sector){
            
            if(id === sector.id){
                return sector
            }else{
                if(sector.children){
                    let result = null;
                    for(let i = 0 ; i < sector.children.length; i++){
                        result = this.findSectorFather(id, sector.children[i]);
                        if(result){
                            return result;
                        }
                    }
                }
                return null;
            }
        }

    },
    
}
</script>

<style scoped>
    .activeSector{
        background-color: rgb(210, 202, 255);
        font-weight: bold;
    }
</style>